export default "__VITE_ASSET__E4sv91OS__"